import { Injectable } from '@angular/core';
import { ApiManagerService } from '../api-manager/api.maganer.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResultsService {
  constructor(private api: ApiManagerService) { }

  getResults(rawParams: any) {
    if (rawParams.page === null) {
      rawParams.page = 1 + '';
      rawParams.limit = 25 + '';
      rawParams.start = 25 + '';
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 25 + '';
    }

    return fetch(`${environment.spooortsSportApi}user/${rawParams.lid}/results/list?ena=${rawParams.ena}&dt=${rawParams.dt}&dist=${rawParams.dist}&t=${rawParams.t}&sw=${rawParams.sw}&limit=${rawParams.limit}&page=${rawParams.page}&start=${rawParams.start}`)
      .then((results) => results.json());
  }

  getCategories(lid: number): Promise<any> {
    return fetch(`${environment.spooortsSportApi}user/${lid}/events/categories`)
    .then(results => results.json());
  }

  getEventNames(lid: number, cid: any): Promise<any> {
    return fetch(`${environment.spooortsSportApi}user/${lid}/events-with-results/names?&cid=${cid}`)
    .then(results => results.json());
  }

  getEventDates(ena: string, cid: any, lid: number): Promise<any> {
    return fetch(`${environment.spooortsSportApi}user/${lid}/events-with-results/dates?ena=${ena}&cid=${cid}`)
    .then(results => results.json());
  }

  getEventDistances(ena: string, dt: string, cid: any, lid: number): Promise<any> {
    return fetch(`${environment.spooortsSportApi}user/${lid}/events-with-results/distances?ena=${ena}&dt=${dt}&cid=${cid}`)
    .then(results => results.json());
  }

  getEventTypes(ena: string, dt: string, dist: string, cid: any, lid: number): Promise<any> {
    return fetch(`${environment.spooortsSportApi}user/${lid}/events/racetypes?ena=${ena}&dt=${dt}&dist=${dist}&cid=${cid}`)
    .then(results => results.json());
  }

  getResultDetails(id:number, cid: number){
    return fetch(`${environment.spooortsSportApi}event/result/${id}/details?cid=${cid}`)
      .then(results => results.json());
  }
}

export interface Pager {
  page: string;
  limit: string;
  start: string;
}